import React from 'react';
import ApplicationCompanyBase from '../components/base/application-company-base';

const GeneralApplicationCompany = () => {
  return <ApplicationCompanyBase sportType="general" />;
};

export default GeneralApplicationCompany;
